import i18next from 'i18next';
import { cityIn } from 'lvovich';

import { ResultsLegFragment } from '@websky/graphql';
import { getDurationString, getFlightDuration } from '../Results/utils';

export const getTransferLabel = (
	t: i18next.TFunction,
	stopCityName: string,
	transferDuration: Duration,
	separator = '-'
) => `${t('Stop in')} ${cityIn(stopCityName)} ${separator} ${getDurationString(transferDuration)}`;

export const getTotalDurationLabel = (t: i18next.TFunction, flight: ResultsLegFragment, separator = '-') =>
	`${t('Total duration')} ${separator} ${getDurationString(getFlightDuration(flight.segments))}`;
